import { render, staticRenderFns } from "./VersionCascader.vue?vue&type=template&id=0ea8b192&scoped=true&"
import script from "./VersionCascader.vue?vue&type=script&lang=js&"
export * from "./VersionCascader.vue?vue&type=script&lang=js&"
import style0 from "./VersionCascader.vue?vue&type=style&index=0&id=0ea8b192&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea8b192",
  null
  
)

export default component.exports